// increment
export function load(menu) {
  return {
    type: "LOAD_MENU",
    menu
  };
}

export function expandSubmenu(index) {
  return {
    type: "EXPAND_MENNU",
    index
  };
}

export function collapseSubmenu(index) {
  return {
    type: "COLLAPSE_MENU",
    index
  };
}

export function collapseAll() {
  return {
    type: "COLLAPSE_ALL"
  };
}
